/**
 * Copyright © 2026 Adnuntius AS.
 */

export const ASPECT_RATIOS_TRANSLATIONS: Record<string, string> = {
  'CUSTOM': '-- custom aspect ratio --',
  'VERTICAL_9X16': '9:16 (Vertical)',
  'NEAR_SQUARE_VERTICAL_4X5': '4:5 (Near Square)',
  'SQUARE_1X1': '1:1 (Square)',
  'NEAR_SQUARE_5X4': '5:4 (Near Square)',
  'SCREEN_4X3': '4:3 (Screen)',
  'PHOTO_3X2': '3:2 (Photo)',
  'WIDE_RECTANGLE_8X5': '8:5 (Wide Rectangle)',
  'WIDESCREEN_16X9': '16:9 (Widescreen)',
  'HORIZONTAL_1_91X1': '1.91:1 (Horizontal)',
  'WIDE_2X1': '2:1 (Wide)',
  'VERY_WIDE_3X1': '3:1 (Very Wide)',
  'SUPER_WIDE_6X1': '6:1 (Super Wide)'
};

export const ASPECT_RATIOS = [
  {id: 'CUSTOM'},
  {id: 'VERTICAL_9X16'},
  {id: 'NEAR_SQUARE_VERTICAL_4X5'},
  {id: 'SQUARE_1X1'},
  {id: 'NEAR_SQUARE_5X4'},
  {id: 'SCREEN_4X3'},
  {id: 'PHOTO_3X2'},
  {id: 'WIDE_RECTANGLE_8X5'},
  {id: 'WIDESCREEN_16X9'},
  {id: 'HORIZONTAL_1_91X1'},
  {id: 'WIDE_2X1'},
  {id: 'VERY_WIDE_3X1'},
  {id: 'SUPER_WIDE_6X1'}
];
